import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Input from 'components/Input';
import CutoffsFields from './CutoffsFields';
import {
  makeRangeValidator,
  makeIntegerRangeValidator
} from 'utilities/validators.js';

const numberOfTrialsValidator = makeIntegerRangeValidator(1, 1000);
const probabilityValidator = makeRangeValidator(0, 1);

const BinomialDistributionFieldsComponent = props => (
  <>
    <div className="flex space-between baseline">
      <Field
        name="numberOfTrials"
        label="Number of Fixed Trials (n)"
        type="number"
        component={Input}
        validate={numberOfTrialsValidator}
        onChange={props.onNumberOfTrials}
        wrapperClassName="mb-15 relative width-48"
        inputClassName="main-input__input"
      />

      <Field
        min={0}
        max={1}
        step={0.1}
        name="probabilityOfSuccess"
        type="number"
        component={Input}
        label="Probability of Success (p)"
        validate={probabilityValidator}
        onChange={props.onProbabilityOfSuccess}
        wrapperClassName="mb-15 relative width-48"
        inputClassName="main-input__input"
      />
    </div>
    <p className="font-700 mb-0 mt-5">
      Probability
    </p>
    <CutoffsFields />
  </>
);


BinomialDistributionFieldsComponent.propTypes = {
  onNumberOfTrials: PropTypes.func.isRequired,
  onProbabilityOfSuccess: PropTypes.func.isRequired
};

export default BinomialDistributionFieldsComponent;
